export const signupreq="singupreq"
export const signupsucc="singupsucc"
export const signupfail="signupfail"